export default "__VITE_ASSET__BVWaM1QG__"